import React, { useRef, useEffect } from 'react';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useDispatch } from 'react-redux';
import { usePagination } from '../../pages/arc/shared-slices/usePagination';
import { goToPage } from '../../pages/arc/shared-slices/pagination-slice';
import { paginationStyles } from '../../global/constants/theme/styles/components/pagination';
import { buttonStyles } from '../../global/constants/theme/styles/components/buttonstyles';


interface ListPaginationProps {
	name: string,
	totalPages: number,
	nextButton: string,
	prevButton: string,
	totalCounts: number,
	scrollToTopOnPageChange?: boolean,
}

export const ListPagination = (props: ListPaginationProps) => {
	const dispatch = useDispatch();	

	const pagination = usePagination(props.name, props.totalPages, 1);
	const classes = paginationStyles();
	const buttonClasses = buttonStyles();
	const skipInitialScroll = useRef(true);
	const currentPage = pagination?.currentPage;

	useEffect(() => {
		if (skipInitialScroll.current) {
			skipInitialScroll.current = false;
			return;
		}
		if (!props.scrollToTopOnPageChange) return;
		window.requestAnimationFrame(() => {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		});
	}, [currentPage, props.scrollToTopOnPageChange]);
	
	useEffect(() => {
		if (!pagination) return;
		if (props.totalPages >= 1 && pagination.currentPage > props.totalPages) {
			dispatch(goToPage(props.totalPages, pagination.name));
		}
	}, [props.totalPages, pagination?.currentPage, pagination?.name]);

	if (!pagination) {
		return null;
	}

	const lastPage = props.totalPages || pagination.lastPage;
	const activePage = Math.min(pagination.currentPage, lastPage);

	const next = () => {
		dispatch(goToPage(activePage + 1, pagination.name));
	};

	const prev = () => {
		dispatch(goToPage(activePage - 1, pagination.name));
	};

	const hidePagination = lastPage <= 1;

	const getBeginCount = (page: number) => {
		return page * 10 - 9;
	};

	const getEndCount = (page: number, totalCount) => {
		return page * 10 > totalCount ? totalCount : page * 10;
	};

	if (props.totalCounts < 10) {
		return null;
	}
	return (
		<>
			{
				!hidePagination ?
					<div className={`${classes.paginationContainer} table-pagination`}>
						<div className='pagination-inner'>
							<button type='button' aria-label={props.prevButton} className={`${buttonClasses.secondaryButton} pagination-icon-btn`} disabled={activePage <= pagination.firstPage} onClick={prev}>
								<ArrowBackIosIcon />
							</button>							

							<div className='pagination-text'>
								{`${getBeginCount(activePage)}-${getEndCount(activePage, props.totalCounts)} of ${props.totalCounts}`}
							</div>							

							<button type='button' aria-label={props.nextButton} className={`${buttonClasses.secondaryButton} ${buttonClasses.iconButtonRight} pagination-icon-btn`} disabled={activePage >= lastPage} onClick={next}>
								<ArrowForwardIosIcon />
							</button>
						</div>
					</div>
					: null
			}
		</>
	);
};

ListPagination.defaultProps = {
	scrollToTopOnPageChange: false,
};
